import {
  RiskErrorViewerState,
  Reducer,
  ReducerActions,
  riskErrorViewerStateActions,
  RiskErrorViewerStateAction,
} from '@/context/types';

const makeRiskErrorViewerStateInitialState = (): RiskErrorViewerState => ({
  isOpen: false,
  isLoading: true,
  data: { errors: [], disclaimers: [] },
});

const reducerActions: ReducerActions<RiskErrorViewerState, RiskErrorViewerStateAction> = (state, payload) => ({
  risk_error_viewer_close: () => ({ ...state, isOpen: false, data: { errors: [], disclaimers: [] } }),
  risk_error_viewer_populate: () => ({ ...state, isOpen: true, data: { ...payload } }),
  risk_error_viewer_load_start: () => ({ ...state, isLoading: true }),
  risk_error_viewer_load_end: () => ({ ...state, isLoading: false }),
});

export const riskErrorViewerReducer: Reducer<RiskErrorViewerState, RiskErrorViewerStateAction> = (
  state,
  { action, payload },
) => (riskErrorViewerStateActions.includes(action) ? reducerActions(state, payload)[action]() : { ...state });

riskErrorViewerReducer.key = 'riskErrorViewer';
riskErrorViewerReducer.initialState = makeRiskErrorViewerStateInitialState();
